<template>
  <the-1-column-layout>
    <img v-if="machine.machineImage" :src="machine.machineImage">
    <h2>{{loc('components.customerMachine.machineInformation')}}</h2>
    <div class="row">
      <div class="col-xs-12 col-md-8">
        <table class="table">
          <tr>
            <td class="table__td has-bg">{{loc('serialNumber')}}:</td>
            <td>{{machine.serialNumber}}</td>
          </tr>
          <tr v-if="machine.deliveryDateWarranty && machine.deliveryDateWarranty.formatted">
            <!-- <td class="table__td has-bg">{{loc('customerMachineWarrantyRegistered')}}:</td> -->
            <td class="table__td has-bg">{{loc('deliveryDateSold')}}:</td>
            <td>{{machine.deliveryDateWarranty.formatted}}</td>
          </tr>
          <tr v-if="machine.deliveryDate && machine.deliveryDate.formatted">
            <td class="table__td has-bg">{{loc('customerMachineWarrantyRegistered')}}:</td>
            <td>{{machine.deliveryDate.formatted}}</td>
          </tr>
          <tr v-if="machine.dateAdded && machine.dateAdded.formatted">
            <td class="table__td has-bg">{{loc('dateAddedMachine')}}:</td>
            <td>{{machine.dateAdded.formatted}}</td>
          </tr>
          <tr v-if="machine.manufacturingDate && machine.manufacturingDate.formatted">
            <td class="table__td has-bg">{{loc('manufacturingDate')}}:</td>
            <td>{{machine.manufacturingDate.formatted}}</td>
          </tr>
          <tr>
            <td class="table__td has-bg">{{loc('company')}}:</td>
            <td v-if="machine.retail_customer_name">{{machine.retail_customer_name}}</td>
            <td v-else>{{machine.companyName}}</td>
          </tr>
          <tr>
            <td class="table__td has-bg">{{loc('country')}}:</td>
            <td>{{machine.country.name}}</td>
          </tr>
          <tr>
            <td class="table__td has-bg td">{{loc('additionalInformation')}}:</td>
            <td>
              <div class="d-flex justify-content-between">
                <div v-if="!editorActivated" class="flex-fill">
                  <pre>{{machine.additionalInformation}}</pre>
                </div>
                <div v-else class="d-flex flex-column flex-fill">
                  <textarea
                    class="mb-1 form-control textarea__fit-content"
                    id="textarea"
                    :value="additionalInformation"
                    @input="handleInput">
                  </textarea>
                  <div class="d-flex">
                    <button :class="saveBtnVisibile ? 'visible' : 'invisible'" :disabled="saveDisabled" @click="save" class="btn btn--white save--btn">
                      {{loc('save')}}
                    </button>
                    <div :class="showSaveMessage ? 'visible' : 'invisible'" class="save--message">
                      {{savedSuccessfully ? loc('savedSuccessfully') : loc('failedToSave')}}
                    </div>
                  </div>
                </div>
                <div class="textarea__edit-icon">
                  <span v-if="editMachineInfoPermission" class="icon icon--pencil--black" role="button" @click="activateEditor"></span>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <br />
      </div>
      <div class="col-xs-12 col-md-4">
        <a v-if="machine.machinePage" class="btn btn--white" :href="machine.machinePage" target="_blank">
          {{loc('components.customerMachine.machinePresentation')}}
        </a>
      </div>
    </div>
    <div v-if="ownerPermission" class="owner-change">
      <div class="row">
        <div class="col-xs-12 col-md-4">
          <button class="btn btn--white" v-on:click="machineOwnerUpdated = false; ownerForm = !ownerForm;" target="_blank">
            {{loc('components.customerMachine.machineOwnership')}}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div v-if="machineOwnerUpdated" class="updated">
            <div class="success" >
              {{loc('components.customerMachine.machineOwnerUpdated')}}
            </div>
          </div>
          <div v-else class="col-xs-12 col-md-12">
            <div v-if="ownerForm" class="ownerform">
              <h3>{{loc('components.customerMachine.machineNewOwner')}}</h3>
              <v-form :fields="fields" :form-data="formData" :form-errors="formErrors">
                <div slot="buttons" class="v-form-button-div">
                  <button :disabled="sendDisabled" v-on:click="update" type="submit" class="btn btn--white">
                    {{loc('updateInformation')}}
                  </button>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="complaints.length">
      <h2>{{loc('complaints')}}</h2>
      <v-client-table :columns="columns" :data="filteredComplaintsData" :options="options">
        <router-link slot="uuid" slot-scope="props" :to="{ name: 'complaint', params: { id: props.row.uuid }}">{{props.row.uuid}}</router-link>
      </v-client-table>
    </div>
    <!-- hide for now <div v-if="machineDetails.data">
      <h2>{{loc('components.customerMachine.machineData')}}</h2>
      <table class="table table--fluid table--narrow-first-col">
        <tr v-for="(data, key) in machineDetails.data" v-bind:key="key">
          <td class="table__td has-bg">{{data.name}}</td><td>{{data.value}} {{data.unit}}</td>
        </tr>
      </table>
    </div>-->
  </the-1-column-layout>
</template>

<script>

import VForm from './v-form.vue';

export default {
  components: {
    'v-form': VForm
  },
  name: 'ViewCustomerMachine',
  data: function () {
    return {
      serialNumber: '',
      searchColumns: ['uuid', 'serialNumber', 'dateAdded', 'status', 'deliveryDate'],
      columns: ['uuid', 'serialNumber', 'dateAdded', 'status', 'deliveryDate'],
      sortable: ['uuid', 'serialNumber', 'dateAdded', 'status', 'deliveryDate'],
      filterable: ['uuid', 'serialNumber', 'dateAdded', 'status', 'deliveryDate'],
      selected: '10',
      formData : {},
      formErrors: {},
      ownerPermission: false,
      editMachineInfoPermission: false,
      editorActivated: false,
      saveDisabled: true,
      saveBtnVisibile: false,
      additionalInformation: '',
      showSaveMessage: false,
      savedSuccessfully: false,
      ownerUpdated: false,
      machineOwnerUpdated: false,
      ownerForm : false,
      sendDisabled: false
    }
  },
  computed: {
    fields() {
      if(this.$store.getters.childCompaniesOptions) {
        return [{
          name: 'id',
          value: this.$store.state.user.info.id,
          label: 'id',
          type: 'hidden'
        },{
          name: 'childCompanyId',
          value: this.machine.customerNumber,
          label: this.loc('company'),
          options: this.$store.getters.childCompaniesOptions,
          type: 'select'
        },{
          name: 'serialNumber',
          value: this.serialNumber,
          label: this.loc('serialNumber'),
          type: 'hidden'
        }];
      }

      return [{
        name : 'id',
        value: '',
        label: this.loc('company'),
        type : 'text'
      },{
        name: 'serialNumber',
        value: this.serialNumber,
        label: this.loc('serialNumber'),
        type: 'hidden'
      }];
    },
    filteredComplaintsData() {
      const self = this;
      const searchText = this.$store.state.subheader.searchText; // Use subheader search input for searching
      const data = this.complaints;

      if(searchText) {
        const searchRegEx = new RegExp(searchText, 'i')

        return data.filter(function (item) {
          for(let i=0, l=self.searchColumns.length; i<l; i++) {
            const column = self.searchColumns[i];

            if(searchRegEx.test(item[column])) {
              return true;
            }
          }
          return false;
        });
      }
      return data;
    },
    complaintsOptions() {
      return {
        filterable: false,
        headings: {
          uuid: this.loc('complaintId'),
          serialNumber: this.loc('serialNumber'),
          dateAdded: this.loc('dateAddedComplaint'),
          status: this.loc('status'),
          deliveryDate: this.loc('deliveryDateComplaint')
        },
        texts: {
            count: this.loc('paginationCount'),
            limit: this.loc('records'),
            noResults: this.loc('noMatchingResults'),
        }
      }
    },
    options() {
      return {
        filterable: false,
        headings: {
          uuid: this.loc('complaintId'),
          serialNumber: this.loc('serialNumber'),
          dateAdded: this.loc('dateAddedComplaint'),
          status: this.loc('status'),
          deliveryDate: this.loc('deliveryDateSold')
        },
        texts: {
            count: this.loc('paginationCount'),
            limit: this.loc('records'),
            noResults: this.loc('noMatchingResults'),
        }
      }
    },
    complaints() {
      return this.$store.state.complaints.filter(complaint => complaint.serialNumber === this.serialNumber).map(complaint => {
        return {
          uuid: complaint.uuid,
          serialNumber: complaint.serialNumber,
          jobsText: complaint.jobsText,
          status: complaint.status && complaint.status.name,
          dateAdded: complaint.dateAdded && complaint.dateAdded.formatted,
          deliveryDate: complaint.deliveryDate
        }
      });
    },
    machine() {
      for(let i=0, l=this.$store.state.customerMachines.length; i<l; i++) {
        if(this.$store.state.customerMachines[i].serialNumber === this.serialNumber) {
          this.$store.commit('setSubheader', {
            subtitle: '',
            title: this.$store.state.customerMachines[i].machineModelName,
            description: '',
            searchEnabled: false
          });
          this.additionalInformation = this.$store.state.customerMachines[i].additionalInformation;
          return this.$store.state.customerMachines[i];
        }
      }

      // If nothing is found
      return {
        country: {},
        deliveryDate: {}
      };
    },
    machineDetails() {
      for(let i=0, l=this.$store.state.customerMachineDetails.length; i<l; i++) {
        if(this.$store.state.customerMachineDetails[i].serialNumber === this.serialNumber) {
          return this.$store.state.customerMachineDetails[i];
        }
      }

      // If nothing is found
      return {};
    }
  },
  methods: {
    async update() {
      this.sendDisabled = true;
      return this.$api.updateCustomerMachineOwner(this.formData.serialNumber, this.formData).then(res => {
        this.sendDisabled = false;

        // Errors in form
        if(res.code === 400) {
          this.formErrors = res.result.fields;
        }


        if(res.code === 200) {
          this.machineOwnerUpdated = true; //show message
          this.$store.dispatch('getCustomerMachine', this.serialNumber); //update machine view
          this.ownerForm = false; //hide form
        }

      });

    },

    activateEditor() {
      this.editorActivated = true;
      this.$nextTick(() => {
        const textarea = document.getElementById('textarea');
        textarea.focus();
        textarea.style.height = textarea.scrollHeight + 'px';
        });
    },

    handleInput(event)  {
      this.saveDisabled = false;
      this.saveBtnVisibile = true;
      this.additionalInformation = event.target.value;
      const element = event.target;
      element.style.height = 'auto';
      element.style.height = element.scrollHeight + 'px'; // adjust textarea height to the input content
    },

    async save() {
      this.saveDisabled = true;

      const data = {
        additionalInformation: this.additionalInformation
      };

      return this.$api.saveCustomerMachineInformation(this.serialNumber, data).then(res => {


        if(res.code === 400 || res.code === 500) {
          console.error(res.result.fields);
          this.savedSuccessfully = false;
        }

        if(res.code === 200) {
          this.savedSuccessfully = true;
          this.$store.dispatch('getCustomerMachine', this.serialNumber); // update machine view
        }

        this.showSaveMessage = true; // show message

        setTimeout(() => { // fade out the saved message and button
            this.showSaveMessage = false;
            this.saveBtnVisibile = this.savedSuccessfully ? false : true;
            this.saveDisabled = this.savedSuccessfully ? true : false;
            }, 2000);

      });
    }

  },
  mounted: function () {

    //Permission to show machine ownership form - true/false
    //retailer, customer and retailer-admin won't get permission

    this.ownerPermission =
      this.$userRights.hasRight( window.RIGHTS.VIEW_OWNERSHIP_FORM, this.$store.state.user.role )
      ? true
      : false;

    this.editMachineInfoPermission =
      this.$userRights.hasRight( window.RIGHTS.EDIT_MACHINE_INFO, this.$store.state.user.role)
      ? true
      : false;

    this.serialNumber = this.$route.params.serialNumber

    this.$store.dispatch('getCustomerMachine', this.serialNumber)
    this.$store.dispatch('getCustomerMachineDetails', this.serialNumber);
    this.$store.dispatch('getChildCompanies');
    this.$store.dispatch('getComplaints', {
      serialNumber: this.serialNumber,
      includeChildCompanies: true
    });

    this.$store.commit('setSubheader', {
      subtitle: '',
      title: '',
      description: '',
      searchEnabled: false
    });
  }
}
</script>
